module.exports = __webpack_public_path__ + "img/iconCircleArrowWhite.d930aad9.png";